/*
 * @Author: jiansuiwang@rastar.com
 * @Date: 2024-09-29 17:21:28
 * @LastEditors: jiansuiwang@rastar.com
 * @LastEditTime: 2024-10-17 09:51:43
 * @FilePath: \game2\src\utils\selectTheme.js
 */
import { getUrlParams } from "./getUrlParams";

export function selectTheme({ appId, pid, md_id }) {
  // Define your logic to select theme based on appId, pid, and md_id
  if (appId === "105409" && pid === "397" && md_id === "200000") {
    return {
      theme: "mswz",
      title: "三國屍心瘋",
    };
  }
  // Add more conditions as needed
  return null; // Fallback theme
}

export function setTheme() {
  const urlParams = getUrlParams();
  const selectedTheme = selectTheme(urlParams);

  if (!selectedTheme) {
    return;
  }
  // 设置页面title
  document.title = selectedTheme.title;

  // 动态设置 所有icon
  // document.querySelectorAll("link[rel*='icon']").forEach(icon => {
  //   icon.href = "src/assets/mswz/assets/default.png";
  // });

  // 修改manifest.json
  // const manifest = document.querySelector("link[rel='manifest']");
  // if (manifest) {
  //   manifest.href ="src/assets/mswz/assets/manifest.json";
  // } else {
  //   const manifest = document.createElement("link");
  //   manifest.rel = "manifest";
  //   manifest.href = "src/assets/mswz/assets/manifest.json";
  //   document.head.appendChild(manifest);
  // }

  // 动态设置data-theme
  document.documentElement.setAttribute("data-theme", selectedTheme.theme);
}
